import {
  RESET_COMPANIES,
  RESET_COMPANY,
  RESET_ERROR,
  GET_COMPANIES,
  SET_COMPANIES,
  API_ERROR,
  CREATE_COMPANY,
  CREATE_COMPANY_SUCCESS,
  GET_COMPANY,
  SET_COMPANY,
  EDIT_COMPANY,
  EDIT_COMPANY_SUCCESS,
  ACTIVATE_COMPANY,
  ACTIVATE_COMPANY_SUCCESS,
  CLEAN_QUEUE,
  CLEAN_QUEUE_SUCCESS,
  RESET_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorCompany: false,
  loadingCompany: false,
  dataCompany: null,
  successCompany: false,
};

const Company = (state = initialState, action) => {
  switch (action.type) {
    case RESET_COMPANIES:
      state = {
        ...state,
        errorCompany: false,
        loadingCompany: false,
        loadingCompanyActivate: false,
        successCompany: false,
        dataCompany: null,
        dataCompanyActivate: null,
      };
      break;
    case RESET_COMPANY:
      state = {
        ...state,
        errorCompany: false,
        loadingCompany: false,
        successCompany: false,
        dataCompanyGetSet: null,
        dataCompanyEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorCompany: false,
        loadingCompany: false,
        loadingCompanyEditCreate: false,
        loadingCompanyActivate: false,
        successCompany: false,
      };
      break;
    case GET_COMPANIES:
      state = {
        ...state,
        errorCompany: false,
        loadingCompany: true,
        dataCompany: null,
      };
      break;
    case SET_COMPANIES:
      state = {
        ...state,
        errorCompany: false,
        loadingCompany: false,
        dataCompany: action.payload,
      };
      break;
    case CREATE_COMPANY:
      state = {
        ...state,
        errorCompany: false,
        loadingCompanyEditCreate: true,
        dataCompanyEditCreate: action.payload,
        successCompany: false,
      };
      break;
    case CREATE_COMPANY_SUCCESS:
      state = {
        ...state,
        errorCompany: false,
        loadingCompanyEditCreate: false,
        dataCompanyEditCreate: action.payload,
        successCompany: true,
      };
      break;
    case GET_COMPANY:
      state = {
        ...state,
        errorCompany: false,
        loadingCompany: true,
        dataCompanyGetSet: null,
      };
      break;
    case SET_COMPANY:
      state = {
        ...state,
        errorCompany: false,
        loadingCompany: false,
        dataCompanyGetSet: action.payload,
      };
      break;
    case EDIT_COMPANY:
      state = {
        ...state,
        errorCompany: false,
        loadingCompanyEditCreate: true,
        dataCompanyEditCreate: action.payload,
        successCompany: false,
      };
      break;
    case EDIT_COMPANY_SUCCESS:
      state = {
        ...state,
        errorCompany: false,
        loadingCompanyEditCreate: false,
        dataCompanyEditCreate: action.payload,
        successCompany: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorCompany: action.payload,
        loadingCompany: false,
        loadingCompanyActivate: false,
        loadingCompanyCleanQueue: false,
        successCompany: false,
      };
      break;
    case ACTIVATE_COMPANY:
      state = {
        ...state,
        errorCompany: false,
        loadingCompanyActivate: true,
        dataCompanyActivate: null,
        successCompany: false,
      };
      break;
    case ACTIVATE_COMPANY_SUCCESS:
      state = {
        ...state,
        errorCompany: false,
        loadingCompanyActivate: false,
        dataCompanyActivate: action.payload,
        successCompany: true,
      };
      break;
      case CLEAN_QUEUE:
        state = {
          ...state,
          errorCompany: false,
          loadingCompanyCleanQueue: true,
          dataCompanyCleanQueue: null,
          successCompany: false,
        };
        break;
      case CLEAN_QUEUE_SUCCESS:
        state = {
          ...state,
          errorCompany: false,
          loadingCompanyCleanQueue: false,
          dataCompanyCleanQueue: action.payload,
          successCompany: true,
        };
        break;
        case RESET_SUCCESS:
      state = {
        ...state,
        errorCompany: false,
        loadingCompany: false,
        successCompany: false,
        dataCompanyCleanQueue: null,
      };
      break;
    default:
      // state = { ...state, error: false, loading: false };
      break;
  }
  return state;
};

export default Company;
